import React from 'react';
import './Home.css'

const Footer = () => {
    return (
        <div className="container text-center footer" style={{ marginTop: '80px', padding: '30px' }}>
            <p className="title-color">What's next?</p>

            <p>I'd Love to hear from you . Whether you have a question or just want to say hi, fell free to drop a message. I'll try my best to get back to you!
            </p>

        </div>
    );
};

export default Footer;